import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { universalScrollTo } from '../../../utils/navigationUtils';

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      universalScrollTo(0, 0, 'auto');
    }
  }, [pathname, hash]);

  return null;
}
